export const AUDIO_SHOW_RESET = 'AUDIO_SHOW_RESET';
export const AUDIO_SHOW_SET_ERROR = 'AUDIO_SHOW_SET_ERROR';
export const AUDIO_SHOW_SET_RETRIEVED = 'AUDIO_SHOW_SET_RETRIEVED';
export const AUDIO_SHOW_TOGGLE_LOADING = 'AUDIO_SHOW_TOGGLE_LOADING';



// WEBPACK FOOTER //
// ./src/store/modules/audio/show/mutation_types.js